module.exports = __webpack_public_path__ + "img/template5.da0279f2.png";